import React, {Component, Fragment} from "react";
import {Input} from "reactstrap";
import AutoTextarea from "./AutoTextarea";
import uuidv4 from 'uuid/v4';
import Checkbox from "../../../shared/forms/Checkbox";

class PbleForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      formTitle: '',
      allowOitToChoosePble: false
    };
  }

  componentDidMount() {
    this.setState({
      list: this.initialCategories,
      allowOitToChoosePble: this.props.initialValues ? this.props.initialValues.allowOitToChoosePble: false
    })
  }

  addItemToList() {
   this.setState({
     list: [...this.list, {
       id: uuidv4(),
       title: null,
       subTitle: null,
       description: null
     }]
   })
  }

  handleCategoryChange(e, i) {
    const { value } = e.target;
    this.setState({
      list: this.list.map((c, j) => {
        if(i === j) {
          return {
            ...c,
            id: c.id || uuidv4(),
            title: value,
          }
        }
        return c
      })
    })
  }
  handleCategorySubTitleChange(e, i) {
    const { value } = e.target;
    this.setState({
      list: this.list.map((c, j) => {
        if(i === j) {
          return {
            ...c,
            id: c.id || uuidv4(),
            subTitle: value,
          }
        }
        return c
      })
    })
  }
  handleCategoryDescriptionChange(value, i) {
    console.log('e,i', value,i)
    this.setState({
      list: this.list.map((c, j) => {
        if(i === j) {
          return {
            ...c,
            id: c.id || uuidv4(),
            description: value,
          }
        }
        return c
      })
    })
  }

  removeListItemClick(i) {
    this.setState({
      list: this.list.filter((c, j) => j !== i)
    })
  }

  handleFormTitleChange(e) {
    this.setState({
      formTitle: e.target.value
    });
  }

  updateAllowOitToSelectPble(val) {
    this.setState({
      allowOitToChoosePble: val
    })
  }

  handleDescriptionInput(e) {
    console.log('EVENT', e)
  }

  get formTitle() {
    if (this.props.initialValues && this.props.initialValues.form_title && this.state.formTitle == '') {
      return this.props.initialValues.form_title
    }

    return this.state.formTitle;
  }

  get initialCategories() {
    return this.props.initialValues && this.props.initialValues.list ? this.props.initialValues.list : [];
  }

  get list() {
    return this.state.list;
  }

  handleSubmit() {
    this.props.onSave({
      list: this.list,
      allowOitToChoosePble: this.state.allowOitToChoosePble,
      form_title: this.formTitle,
    });
  }

  render() {
    console.log('this.list', this.list)
    return (
      <div className="pble-form call-log-field">
        <div className="form-title">
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                Form Title
              </label>
            </div>

            <div className="input-conatiner">
              <Input
                name="form-title"
                onChange={this.handleFormTitleChange.bind(this)}
                placeholder="Form Title"
                type="text"
                value={this.formTitle}
              />
            </div>
          </div>
          <div className="field-config-container">
            <div className="label-container">
              <label className="input-type">
                PBLEs
              </label>
            </div>

            {this.list.map((category, i) => (
             <Fragment key={`${i}-options`} >
               <div key={`${i}`} className="select-options-container">
                 <Input
                   onChange={(e) => this.handleCategoryChange(e, i)}
                   placeholder="Title"
                   type="text"
                   value={category.title || ''}
                 />

                 <div className="delete-container">
                   <button className="button danger small" type="button" onClick={this.removeListItemClick.bind(this, i)} >
                     <i className="fa fa-trash"/>
                   </button>
                 </div>
               </div>
               <div key={`${i}-sub-title`} className="select-options-container">
                 <Input
                   onChange={(e) => this.handleCategorySubTitleChange(e, i)}
                   placeholder="Sub title"
                   type="text"
                   value={category.subTitle || ''}
                 />
               </div>
               <div key={`${i}-description`} className="select-options-container">
                 <AutoTextarea
                   value={category.description || ''}
                   placeholder="Description"
                   onChange={(value) => this.handleCategoryDescriptionChange(value, i)}
                 />
               </div>
             </Fragment>
            ))
            }
            <button className="button primary small" onClick={() => this.addItemToList()}>
              Add PBLE category
            </button>

          </div>
          <div className="field-config-container">
            <Checkbox
              label="Allow OIT to choose PBLE"
              checked={this.state.allowOitToChoosePble}
              onChange={e => this.updateAllowOitToSelectPble(e.target.checked)}
            />
          </div>

        </div>

        <button className="button primary large log-field-save" type="button" onClick={this.handleSubmit.bind(this)} >
          Save
        </button>
      </div>
    )
  }
}

export default PbleForm
